import { Component, OnInit } from '@angular/core';
import {ICellEditorAngularComp} from 'ag-grid-angular';
import {StorageService} from '../../../services/storage.service';

@Component({
  selector: 'app-cell-editor-shipping-tags',
  templateUrl: './cell-editor-shipping-tags.component.html',
  styleUrls: ['./cell-editor-shipping-tags.component.scss']
})
export class CellEditorShippingTagsComponent implements ICellEditorAngularComp, OnInit {
  private params: any;
  public shippingTags: any[] = [];
  public selected: any = {};

  constructor(
    private storageService: StorageService
  ) {
    this.shippingTags = this.shippingTags.concat(storageService.shippingTags);
  }

  ngOnInit(): void {
  }

  agInit(params: any): void {
    this.params = params || {};
    this.selected = params?.value || {};
  }

  changeTag(event: any): void {
    this.selected = this.shippingTags.find(tag => tag._id === event.value);
    console.log('changeTag', this.selected);
    // if (this.selected.name === 'Not Selected') {
    //   this.selected = undefined;
      this.params.api.stopEditing();
    // } else {
    //   this.params.api.stopEditing();
    // }
  }

  getValue(): any {
    console.log('getValue', this.selected);
    return this.selected;
  }
}
